<template>
  <el-dialog
    :visible.sync="cutDialogVisiable"
    append-to-body
    :close-on-press-escape="false"
    top="8vh"
    class="cut-img-container"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <div class="cut-image-wrap">
      <div class="cut-wrap-header">
        <div class="header-left" @click="closeCut">
          <i class="el-icon-back"></i>
          <p>圖片編輯</p>
        </div>
        <div class="header-right" @click="submitImg">
          <p v-if="!loading">應用</p>
          <i v-else class="el-icon-loading"></i>
        </div>
      </div>
      <vueCropper
        ref="cropper"
        :img="beforeUrl"
        outputType="png"
        :canMoveBox="false"
        :autoCrop="true"
        autoCropWidth="400px"
        :autoCropHeight="userInfo && userInfo.userKind === 'Normal' ?'400px' :'440px'"
        fixedBox
        infoTrue
        :info="false"
        centerBox
        mode="cover"
        :canScale="false"
        :class="userInfo && userInfo.userKind === 'Normal' ? 'round-box' : ''"
      ></vueCropper>
      <div class="slider-wrap">
        <i class="el-icon-zoom-out"></i>
        <el-slider
          v-model="imgSize"
        />
        <i class="el-icon-zoom-in"></i>
      </div>
    </div>
  </el-dialog>

</template>

<script>
import { VueCropper }  from 'vue-cropper'
import { uploadImageToS3 } from '@/api'
import { mapGetters } from 'vuex'
export default {
  components: {
    VueCropper,
    //   NormalSelect
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  props: {
    cutDialogVisiable: {
      type: Boolean,
      default: false,
    },
    originData: {
      type: File,
      default: {},
    },
  },
  watch: {
    imgSize(newVal, oldVal) {
      this.$refs.cropper.changeScale((newVal-oldVal)/3)
    }
  },
  data() {
    return {
      imgSize: 0,
      beforeUrl: '',
      loading: false,
    }
  },
  created() {
    this.base64OriginData()
  },
  methods: {
    base64OriginData() {
      let that = this
      let reader = new FileReader();
      reader.readAsDataURL(this.originData);
      reader.onload = function(){
        that.beforeUrl = reader.result
      };
    },
    // submit() {
    //   let that = this
    //   this.$refs.cropper.getCropBlob((data) => {
    //     if(that.userInfo && that.userInfo.userKind === 'Player') {
    //       that.$emit('handleAvatarSuccessP', data)
    //     } else {
    //       that.submitImg(data)
    //     }
    //   })
    // },
    closeCut() {
      this.$emit('closeCut')
    },
    submitImg() {
      // let that = this
      this.$refs.cropper.getCropBlob((data) => {
        const fd = new FormData();
        let f = new File([data], Date.now()+'.png');
        fd.append('file', f);
        if (!this.loading) {
          this.loading = true;
          uploadImageToS3(fd).then(({ data }) => {
            this.$emit('handleAvatarSuccessP', data)
            this.loading = false;
          });
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cut-img-container {
  /deep/ .el-dialog {
    width: 448px;
    margin: 0 auto;
    height: 649px;
    border-radius: 8px;
    .el-dialog__body {
      padding: 0px 0 30px 0;
    }
    .el-dialog__header {
      display: none;
    }
  }
}
.cut-image-wrap {
  width: 100%;
  height: 448px;
  .cut-wrap-header {
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    .header-left {
      display: flex;
      align-items: center;
      font-size: 20px;
      line-height: 23px;
      font-weight: 600;
      color: #222C43;
      cursor: pointer;
      i {
        width: 48px;
        height: 48px;
        background: #E8EAEE;
        border-radius: 100%;
        font-size: 26px;
        line-height: 48px;
        text-align: center;
        font-weight: 600;
        margin-right: 16px;
      }
    }
    .header-right {
      width: 80px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      text-align: center;
      color: #FFFFFF;
      background: #EC5375;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .vue-cropper {
    background: white;
    /deep/ .cropper-crop-box {
      .cropper-view-box {
        outline: 4px solid #EC5375 !important;
      }
      .cropper-face {
        background: none;
      }
    }
  }
  .round-box {
    /deep/ .cropper-crop-box {
      .cropper-view-box {
        position: relative;
        outline: 0px !important;
        border: 4px solid #EC5375 !important;
        border-radius: 100%;
        z-index: 10;
        pointer-events: none;
      }
    }
  }
  .slider-wrap {
    width: 350px;
    margin: 30px auto 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 20px;
    font-weight: 600;
    /deep/ .el-slider {
      width: 280px;
    }
  }
}
</style>